import gql from "graphql-tag";

export default gql`
mutation DeleteEntity($_id: ID!, $_rev: ID, $tpID: ID!) {
    deleteEntity(_id: $_id, _rev: $_rev, tpID: $tpID)
}
`